import React from 'react';
import { withRouter } from 'react-router';
import { Route } from 'react-router-dom';

import { inject } from 'mobx-react';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { SOURCE_TYPES } from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';
import PropTypes from 'prop-types';

@withRouter
@inject((stores) => ({
  onlineEvent: stores.MembershipStore.onlineEvent,
  loadedMembership: stores.MembershipStore.loaded
}))
export class RouteWrapper extends React.Component {
  componentDidMount() {
    this.sendPageEvent();
  }

  sendPageEvent() {
    const {
      location,
      track: subsection,
      onlineEvent,
      loadedMembership
    } = this.props;

    if (!loadedMembership) {
      return;
    }

    const sourceType = onlineEvent
      ? SOURCE_TYPES.ONLINE_EVENT
      : SOURCE_TYPES.ONLINE_COURSE;

    GtagService.sendPageEvent({ subsection, sourceType });

    DatahubService.sendPageViewEvent(location, location);
  }

  render() {
    return <Route {...this.props} />;
  }
}

RouteWrapper.propTypes = {
  location: PropTypes.object,
  track: PropTypes.string,
  pathname: PropTypes.string,
  onlineEvent: PropTypes.bool,
  loadedMembership: PropTypes.bool
};

export function renderRoutes(routes = []) {
  return routes.map((item) => (
    <RouteWrapper
      track={item.track}
      key={`${item.path}`}
      path={`${item.path}`}
      render={(props) => {
        const { component: Component } = item;

        return <Component {...props} />;
      }}
    />
  ));
}
